import React from 'react'
import { Helmet } from 'react-helmet-async'
import { BillingDetailsLayout } from '../../layouts/Billing'

const BillingDetailsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Billing Details</title>
      <meta name="description" content="Billing Details page" />
    </Helmet>
    <BillingDetailsLayout />
  </React.Fragment>
)

export default BillingDetailsPage
